import request from '@/utils/request'

let ZhaoshangApi = {

  /*政府园区列表*/
  list(data) {
    return request._post('/shop/plus.zhaoshang.Index/index', data);
},
/*添加政府园区*/
add(data) {
    return request._post('/shop/plus.zhaoshang.Index/add', data);
},
shelves(data){
      return request._post('/shop/plus.zhaoshang.Index/shelves', data);
},
/*修改政府园区*/
edit(data) {
    return request._post('/shop/plus.zhaoshang.Index/edit', data);
},
/*删除政府园区*/
del(data) {
    return request._post('/shop/plus.zhaoshang.Index/del', data);
},
/*政府园区详情*/
detail(data) {
  return request._post('/shop/plus.zhaoshang.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.zhaoshang.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.zhaoshang.Setting/getSetting', data, errorback);
    },
}
export default ZhaoshangApi;



// WEBPACK FOOTER //
// ./src/api/zhaoshang.js